<template>
  <div class="wrapper" >
    <el-row :gutter="80" class="posts-placeholder-el-row" :class="screenWidth<=768?'pl-20 pr-20':''">
      <el-col v-for="(n,idx) in postsList" :key="idx" :span="12" :xs="24">
        <div :style="screenWidth>768?offsetBottom(idx):''" class="posts-placeholder-item pr lf-0">
          <div class="hot-posts-item-img graylight-bg pr ht-100x">
          </div>
          <div class="pr" :class="screenWidth>768?'pt-24':'pt-14'" >
            <div class="posts-placeholder-tags graylight-bg" :style="screenWidth>768?'':'width:'+screenWidth*0.4+'px;'">
            </div>
            <div class="posts-placeholder-title serif graylight-bg" :style="screenWidth>768?'':'width:'+screenWidth*0.6+'px;'"></div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'postsPlaceholder',
  computed: {
    ...mapGetters([
      'scrollHeight',
      'screenWidth'
    ])
  },
  data () {
    return {
      postsList: [{}, {}, {}, {}, {}, {}]
    }
  },
  watch: {
    scrollHeight (val) {
      this.offsetBottom()
    }
  },
  methods: {
    offsetBottom (idx) {
      let res = ''
      if (idx % 2 === 1) {
        res = 'bottom: ' + (this.scrollHeight * 7 - 100) + 'px'
      } else {
        res = 'bottom: ' + this.scrollHeight * 2 + 'px'
      }
      return res
    }
  }
}
</script>
<style>
.posts-placeholder-el-row {
  display: flex;
  flex-wrap: wrap;
}
.posts-placeholder-title {
  font-size: 1.375em;
  font-weight: 600;
  /* 宽*0.6 */
  width: 240px;
  height: 35px;
}
.posts-placeholder-item {
  margin-bottom: 4em;
}
.hot-posts-item-img {
  height: 18em;
}
.posts-placeholder-tags {
  font-size: 0.875em;
  width: 160px;
  height: 20px;
  margin-bottom: 10px;
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .posts-placeholder-title {
    font-size: 28px;
    font-weight: 600;
    width: 250px;
    height: 40px;
  }
  .posts-placeholder-item {
    margin-bottom: 70px;
  }
  .hot-posts-item-img {
    height: 275px;
  }
  .posts-placeholder-tags {
    font-size: 15px;
    width: 200px;
    height: 20px;
    margin-bottom: 10px;
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .posts-placeholder-title {
    font-size: 32px;
    font-weight: 600;
    width: 350px;
    height: 45px;
  }
  .posts-placeholder-item {
    margin-bottom: 70px;
  }
  .hot-posts-item-img {
    height: 355px;
  }
  .posts-placeholder-tags {
    font-size: 15px;
    width: 250px;
    height: 25px;
    margin-bottom: 10px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .posts-placeholder-title {
    font-size: 38px;
    font-weight: 600;
    width: 400px;
    height: 50px;
  }
  .posts-placeholder-item {
    margin-bottom: 80px;
  }
  .hot-posts-item-img {
    height: 440px;
  }
  .posts-placeholder-tags {
    font-size: 16px;
    width: 300px;
    height: 30px;
    margin-bottom: 10px;
  }
}
@media screen and (min-width: 1920px) {
  .posts-placeholder-title {
    font-size: 46px;
    font-weight: 600;
    width: 500px;
    height: 60px;
  }
  .posts-placeholder-item {
    margin-bottom: 80px;
  }
  .hot-posts-item-img {
    height: 500px;
  }
  .posts-placeholder-tags {
    font-size: 16px;
    width: 300px;
    height: 40px;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/postsPlaceholder.vue